<i18n>
{
  "ja": {
    "contact": {
      "head": "倉庫をお探しの方は、{newline}いつでもお気軽にご相談ください。"
    }
  }
}
</i18n>

<template>
  <div class="overflow-hidden py-12 text-center text-black" :class="[bgWhite ? 'bg-white' : 'bg-gray-100']">
    <div class="flex flex-wrap items-center container w-7/8 lg:w-auto mx-auto">
      <div class="w-full md:max-w-lg mx-auto my-8">
        <i18n path="contact.head" tag="p" class="font-bold">
          <template #newline><br></template>
        </i18n>
        <div class="mt-16">
          <nuxt-link class="text-center inline-flex items-center justify-center  w-7/8 max-w-xs bg-orange text-white py-4 px-6 md:px-4 rounded-full text-center" to="/contact">
            <span class="text-lg xl:px-4 lg:px-2">お問い合わせ</span><span class="material-icons align-middle ml-4">arrow_forward</span>
          </nuxt-link>
        </div>
      </div>
      <div class="hidden md:block pr-4 pl-10 lg:px-12 w-1/2 lg:w-3/12 lg:order-first">
        <img class="mx-auto" src="~assets/img/index/solutions1.png" srcset="~assets/img/index/solutions1@2x.png 2x" alt="">
      </div>
      <div class="hidden md:block pr-10 pl-4 lg:px-12 w-1/2 lg:w-3/12">
        <img class="mx-auto" src="~assets/img/index/solutions2.png" srcset="~assets/img/index/solutions2@2x.png 2x" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import modalMixin from '@/components/mixins/modalHandler';
export default {
  mixins: [modalMixin],
  props: {
    bgWhite: {
      type: Boolean,
      default: false
    }
  }
}
</script>